import ClickAndCollectSearchListView from './ClickAndCollectSearchListView';

export default ClickAndCollectSearchListView;
